
import { defineComponent } from 'vue'
import LoaderSpinner from '@/components/common/LoaderSpinner.vue'
import { constants } from '@/constants'

export default defineComponent({
  name: 'AsahiPopup',
  components: {
    LoaderSpinner
  },
  props: {
    open: Boolean,
    options: Object,
    iconQuantity: Number,
    customized: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    user () {
      return this.$store.state.auth.user
    }
  },
  data () {
    return {
      isLoading: false
    }
  },
  methods: {
    closePopup () {
      this.$emit('update:open', false)
    },
    onClickMenuItem (link:string, name: string) {
      const regex = /^(http|https)/
      if (link.match(regex)) {
        window.location.href = link
      } else {
        this.$router.push(link)
      }
    },
    handleMenuClick (item: any) {
      if (item.name === 'Logout') {
        this.userLogout()
      } else if (item?.name === 'Szkolenia 2') {
        window.gigya.fidm.saml.initSSO({
          spName: this.getSPName(item?.name),
          redirectURL: item.href
        })
      } else if (item?.name === 'Beercoin 10') {
        window.open(constants.gigyaConfig.ssoRedirectURL)
      }
    },
    userLogout () {
      this.isLoading = true
      const params = {
        UID: this.user.UID,
        callback: this.handleLogout
      }
      window.gigya.accounts.logout(params)
    },
    handleLogout () {
      this.$store.dispatch('logout')
      this.isLoading = false
      window.location.reload()
    },
    getSPName (name: string) {
      let spName = ''
      if (name === 'Szkolenia 2') {
        spName = 'eLearning'
      }
      if (name === 'Beercoin 10') {
        spName = 'beercoin'
      }
      return spName
    }
  }
})
